import { AxiosResponse } from "axios";
import { put } from "redux-saga/effects";
import { api } from "../../libs";
import { loginError } from "../actions/auth";
import {
  blockUserSuccess,
  fetchUserDetailSuccess,
  fetchUsersSuccess,
  IUserBlockRequestAction,
  IUserDetailFetchRequestAction,
  IUserRemoveRequestAction,
  IUsersFetchRequestAction,
  removeUserSuccess,
  usersError,
} from "../actions/users";
import { IJob } from "../types/job";
import { IUser } from "../types/user";

export function* fetchUsersSaga(action: IUsersFetchRequestAction) {
  try {
    const response: AxiosResponse = yield api.users.getAllUsers(action.payload);
    const fetchedUsers: IUser[] = response.data.users;
    yield put(fetchUsersSuccess(fetchedUsers, response.data.page_info));
  } catch (err) {
    if (err.response.status === 401) {
      yield put(loginError(err.message));
    } else {
      yield put(usersError(err.message));
    }
  }
}

export function* fetchUserDetailSaga(action: IUserDetailFetchRequestAction) {
  try {
    const userResponse: AxiosResponse = yield api.users.getUser(
      action.payload.id
    );

    const reviewResponse: AxiosResponse = yield api.users.getReviews(
      action.payload.id
    );

    const jobsResponse: AxiosResponse = yield api.jobs.getAllJobs();

    const fetchedJobs: IJob[] = jobsResponse.data.jobs.filter((job: IJob) => {
      return job.author_id === userResponse.data.data.id;
    });

    yield put(
      fetchUserDetailSuccess({
        ...userResponse.data.data,
        reviews: reviewResponse.data.reviews,
        jobs: fetchedJobs,
      })
    );
  } catch (err) {
    if (err.response.status === 401) {
      yield put(loginError(err.message));
    } else {
      yield put(usersError(err.message));
    }
  }
}

export function* blockUserSaga(action: IUserBlockRequestAction) {
  try {
    yield api.users.block(action.payload.id, action.payload.block);
    yield put(blockUserSuccess(action.payload.id));
  } catch (err) {
    if (err.response.status === 401) {
      yield put(loginError(err.message));
    } else {
      yield put(usersError(err.message));
    }
  }
}

export function* removeUserSaga(action: IUserRemoveRequestAction) {
  try {
    const response = yield api.users.remove(action.payload.id);
    yield put(removeUserSuccess(response.data.data));
  } catch (err) {
    if (err.response.status === 401) {
      yield put(loginError(err.message));
    } else {
      yield put(usersError(err.message));
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/sagas/users.ts